import clsx from 'clsx';
import { h } from 'preact';

const AddToCartButton = ({ currentVariant, handleAddToCart, checkedOptions, isGiftCard, isDonationCard = false }) => (
  <button
    id="main-add-to-cart"
    type="submit"
    className={clsx('button cta-blue w-full !rounded py-[14px] disabled:pointer-events-none disabled:bg-grey-3', {
      'Rise-add-to-cart-button': isGiftCard,
      'px-18 h-fit min-w-[85px] max-w-[85px] py-[15px]': isDonationCard,
      'px-40': !isDonationCard,
    })}
    disabled={!currentVariant?.availableForSale || !checkedOptions.size || !checkedOptions.weight}
    onClick={handleAddToCart}
  >
    {currentVariant
      ? !checkedOptions.weight
        ? window.TMW.Strings.product.selectWeight
        : !checkedOptions.size
          ? window.TMW.Strings.product.selectSize
          : currentVariant?.availableForSale
            ? isDonationCard
              ? window.TMW.Strings.product.addToCartDonate
              : window.TMW.Strings.product.addToCart
            : window.TMW.Strings.product.outOfStock
      : window.TMW.Strings.product.unavailable}
  </button>
);

export default AddToCartButton;
